import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { MediaPickerRemoveButton } from './MediaPickerRemoveButton';
import { MediaViewer } from 'components/media/MediaViewer';
import { React } from 'libs/react';
import { FormSelect } from 'components/form/FormSelect';
import './MediaPickerItem.scss';
/**
 * @component MediaPickerItem
 * @since 1.0.0
 */
export function MediaPickerItem(props) {
    const { size, style, media, editable, types, primary, hasVisibilitySelection, visibilityValues, hasLanguageSelection, languageValues, languageOptions } = Object.assign({ size: 'medium', style: 'normal' }, props);
    const [selected, setSelected] = useState(false);
    const [dragOver, setDragOver] = useState(false);
    const draggable = editable && props.onReorder != null && props.index != null;
    /**
     * @function onItemClick
     * @since 1.0.0
     * @hidden
     */
    function onItemClick() {
        if (props.onItemClick) {
            props.onItemClick(media);
        }
    }
    /**
     * @function onRemove
     * @since 1.0.0
     * @hidden
     */
    function onRemove(media) {
        if (props.onRemove) {
            props.onRemove(media);
        }
    }
    /**
     * @function onDragStart
     * @since 1.0.0
     * @hidden
     */
    function onDragStart(e) {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(props.index));
    }
    /**
     * @function onDragOver
     * @since 1.0.0
     * @hidden
     */
    function onDragOver(e) {
        if (!draggable) {
            return;
        }
        e.preventDefault();
        setDragOver(true);
    }
    /**
     * @function onDragLeave
     * @since 1.0.0
     * @hidden
     */
    function onDragLeave() {
        setDragOver(false);
    }
    /**
     * @function onDrop
     * @since 1.0.0
     * @hidden
     */
    function onDrop(e) {
        e.preventDefault();
        setDragOver(false);
        const from = parseInt(e.dataTransfer.getData('text/plain'), 10);
        if (!isNaN(from) && props.onReorder && props.index != null) {
            props.onReorder(from, props.index);
        }
    }
    const className = classNames('media-picker-item', 'media-picker-item--' + size, 'media-picker-item--' + style, { 'media-picker-item--selected': selected }, { 'media-picker-item--primary': primary }, { 'media-picker-item--selectable': !!onItemClick && editable }, { 'media-picker-item--pdf': types === 'application/pdf' }, { 'media-picker-item--draggable': draggable }, { 'media-picker-item--drag-over': dragOver }, props.className);
    return (React.createElement("div", { className: className, draggable: draggable, onDragStart: draggable ? onDragStart : undefined, onDragOver: onDragOver, onDragLeave: draggable ? onDragLeave : undefined, onDrop: draggable ? onDrop : undefined },
        React.createElement("div", { className: "media-picker-item-background" }, media && React.createElement(MediaViewer, { media: media })),
        editable && (React.createElement("div", null,
            React.createElement("div", { className: "media-picker-item-foreground" },
                props.onItemClick && (React.createElement("div", { className: "media-picker-item-clickzone", onClick: onItemClick })),
                React.createElement(MediaPickerRemoveButton, { media: media, onPress: onRemove })),
            hasVisibilitySelection && (React.createElement(FormSelect, { name: `visibility-${media.id}`, placeholder: t('Choose'), value: visibilityValues ? visibilityValues[media.id] : '', options: [
                    { label: t('Public'), value: 'PUBLIC' },
                    { label: t('Partner'), value: 'PARTNER' },
                    { label: t('Private'), value: 'PRIVATE' }
                ], required: true })),
            hasLanguageSelection && (React.createElement(FormSelect, { name: `language-${media.id}`, placeholder: t('Choose language'), value: languageValues ? languageValues[media.id] : '', options: languageOptions || [] }))))));
}
